import { Col, Row, Spinner, Stack } from 'react-bootstrap';

import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BackendStatusData } from 'src/models/GalenData/BackendStatus.model';
import { GlobalStatus } from 'src/models/GalenData/DeviceDataView.model';
import { Session } from 'src/models/Session.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

import isGradable from 'src/utils/isGradable';

const GlobalStatusObject: Record<GlobalStatus, string> = {
  [GlobalStatus.Null]: 'Awaiting Upload',
  [GlobalStatus.Failed]: 'Server Error',
  [GlobalStatus.InitializerStarted]: 'Initializing',
  [GlobalStatus.InitializerEnded]: 'Initialized',
  [GlobalStatus.ModelsStarted]: 'Analyzing',
  [GlobalStatus.ReportStarted]: 'Generating Results',
  [GlobalStatus.ReportEnd]: 'Complete',
};

const GlobalStack = ({
  session,
  status,
}: {
  session: Session;
  status: BackendStatusData;
}) => {
  const { tCommon } = useUiTranslation();

  const StatusText = (globalStatus: GlobalStatus, gradable: boolean) => {
    if (!gradable) {
      return (
        <Col sm={3} className="text-danger text-end">
          {tCommon(`server.ungradable`)}
        </Col>
      );
    }

    if (globalStatus === GlobalStatus.Failed) {
      return (
        <Col sm={3} className="text-danger text-end">
          {tCommon(`server.serverError`)}
        </Col>
      );
    }

    return (
      <Col sm={3} className="text-gray-400 text-end">
        {tCommon(
          `server.GlobalStatusObject.${GlobalStatusObject[globalStatus]}`,
        )}
      </Col>
    );
  };

  const globalStatus = status.GlobalStatus.value;

  const gradable = isGradable(globalStatus, session);

  return (
    <Stack gap={3}>
      <Row>
        <Col sm={9}>
          {globalStatus === GlobalStatus.Failed || !gradable ? (
            <FontAwesomeIcon icon={faXmarkCircle} className="text-danger" />
          ) : globalStatus === GlobalStatus.ReportEnd && gradable ? (
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary" />
          ) : (
            <Spinner variant="primary" size="sm" />
          )}

          <strong className="ms-3">{tCommon(`server.systemStatus`)}</strong>
        </Col>
        {StatusText(globalStatus, gradable)}
      </Row>
    </Stack>
  );
};

export default GlobalStack;
